<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>
          توزيع الافراد
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="ion-padding text-center">
        <ion-text color="dark">
          <h1 class="text-bold">توزيع الافراد</h1>
        </ion-text>
        <ion-text color="dark">
          <p>
            توزيع الافراد على الخدمات
          </p>
        </ion-text>
      </div>
      <div class="content">
      <ion-list>
        <ion-list-header>
          اولاً الفترة الصباحية
        </ion-list-header>
        <ion-item button @click="pickUser(pos.id, 'm1_morning')" v-for="pos in m1_morning" :key="pos.id">
          <ion-note slot="start">{{ pos.name }}</ion-note>
          <ion-label>{{ pos.user }}</ion-label>
        </ion-item>
        <br />
        <ion-list-header>
          ثانياً الفترة المسائية
        </ion-list-header>
        <ion-item button @click="pickUser(pos.id, 'm1_night')" v-for="pos in m1_night" :key="pos.id">
          <ion-note slot="start">{{ pos.name }}</ion-note>
          <ion-label>{{ pos.user }}</ion-label>
        </ion-item>
      </ion-list>
      </div>
      <ion-picker-controller></ion-picker-controller>
    </ion-content>
  </div>
</template>

<script>
  import db from '@/firebase.js'
  import { getColumns } from '../Picker'

  export default {
    name: 'm1-page',
    data() {
      return {
        users: [],
        m1_morning: [],
        m1_night: [],
      }
    },
    created() {
      // TODO UNF*CK this mess
      db.collection('users').onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
          if (change.type === 'added') {
            this.users.push({
              ...change.doc.data(),
              id: change.doc.id
            })
          }
          if (change.type === 'modified') {
            // https://stackoverflow.com/a/35206193
            let foundIndex = this.users.findIndex(x => x.id == change.doc.id)
            this.users[foundIndex].name = change.doc.data().name
          }
          if (change.type === 'removed') {
            this.users.pop(u => u.id == changes.doc.id)
          }
        })
      })
      db.collection('m1_morning').onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
          if (change.type === 'added') {
            this.m1_morning.push({
              ...change.doc.data(),
              id: change.doc.id
            })
          }
          if (change.type === 'modified') {
            // https://stackoverflow.com/a/35206193
            let foundIndex = this.m1_morning.findIndex(x => x.id == change.doc.id)
            this.m1_morning[foundIndex].name = change.doc.data().name
            this.m1_morning[foundIndex].user = change.doc.data().user
          }
          if (change.type === 'removed') {
            this.m1_morning.pop(u => u.id == changes.doc.id)
          }
        })
      })
      db.collection('m1_night').onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
          if (change.type === 'added') {
            this.m1_night.push({
              ...change.doc.data(),
              id: change.doc.id
            })
          }
          if (change.type === 'modified') {
            // https://stackoverflow.com/a/35206193
            let foundIndex = this.m1_night.findIndex(x => x.id == change.doc.id)
            this.m1_night[foundIndex].name = change.doc.data().name
            this.m1_night[foundIndex].user = change.doc.data().user
          }
          if (change.type === 'removed') {
            this.m1_night.pop(u => u.id == changes.doc.id)
          }
        })
      })
    },
    methods: {
      async pickUser(posId, type) {
        let options = []
        console.log(getColumns, posId, type)
        this.users.forEach(c => options.push(c.name))
        const pickerController = document.querySelector('ion-picker-controller')
        await pickerController.componentOnReady()

        const picker = await pickerController.create({
          columns: getColumns(1, [{ name: 'users', data: options }]),
          buttons: [
            { text: 'الغاء', role: 'cancel' },
            {
              text: 'موافق',
              handler: value => {
                this.updatePosition(posId, value.users.text, type)
              }
            },
          ]
        })
        picker.present()
      },
      updatePosition(pos, user, type) {
        console.log(pos, user, type)
        // switch (type) {
        //   case 'm1_morning':

        //     break;
        //   // case 'night':

        //   //   break;
        //   default:
        //     this.showToast('Unkown option!', 'danger')
        // }
        // let a = db.collection(type, ref => ref.where('id', '==', pos))
        // console.log(a, user)
        db.collection(type)
          .doc(pos)
          .update({ user: user })
      },
      removeUser(id) {
        // console.log(d)
        db.collection('users')
          .doc(id)
          .delete()
          .then(() => {
            this.showToast('تم حذف الفرد', 'primary')
          })
          .catch(() => {
            this.showToast('حدثت مشكلة اثناء حذف الفرد', 'danger')
          })
      },
      showAlert(header, subHeader, inputs, buttons) {
        return this.$ionic.alertController
          .create({
            header,
            subHeader,
            inputs,
            buttons
          })
          .then(a => a.present())
      },
      showToast(msg, color) {
        this.$ionic.toastController
          .create({
            // message: `تم حذف <b>${user.fields.name}</b>`,
            message: msg,
            duration: 2000,
            color: color
          })
          .then(t => t.present())
      }
    }
  }
</script>
<style>
  ion-picker {
    touch-action: none;
  }
</style>
